<template>
  <div class="page-default page-cases">
    <div class="row m-0 page-section">
      <div
        class="col col-md-4 col-lg-3 section-left"
        :class="{ show: showSidebar }"
      >
        <div class="case-container">
          <div class="case-header text-dark">
            <div
              class="d-flex justify-content-center align-items-center"
              :class="{ invisible: cases.length < 1 }"
            >
              Page
              <input
                ref="pageInput"
                class="
                  form-control form-control-default form-control-sm
                  text-center
                  mx-1
                "
                style="width: 40px"
                v-model="inputPage"
                type="number"
                @keydown.enter="$event.target.blur()"
                @blur="changePage(inputPage)"
              />
              of {{ totalPage }}
              <div class="btn-group ml-2">
                <button
                  class="btn btn-light btn-sm border"
                  title="Previous page"
                  :disabled="currentPage <= 1"
                  @click="changePage(currentPage - 1)"
                >
                  ‹
                </button>
                <button
                  class="btn btn-light btn-sm border"
                  title="Next page"
                  :disabled="currentPage >= totalPage"
                  @click="changePage(currentPage + 1)"
                >
                  ›
                </button>
              </div>
            </div>
            <!-- <div class="d-flex align-items-center">
              <button class="btn btn-sm btn-primary" @click="editCase('add')">
                <font-awesome-icon :icon="['fas', 'plus']" />
              </button>
              <div
                class="case-header-icon clickable ml-4 d-block d-md-none"
                @click="toggleSidebar()"
              >
                <font-awesome-icon :icon="['fas', 'times']" />
              </div>
            </div> -->
          </div>
          <div
            class="case-filter"
            style="height: auto; max-height: fit-content"
          >
            <div class="row mx-0 h-100">
              <div class="col-6 px-0 h-100 border-right border-bottom">
                <div class="dropdown">
                  <button
                    class="
                      btn btn-sm btn-block
                      no-focus
                      dropdown-toggle
                      position-relative
                      rounded-0
                      py-0
                      px-2
                      d-flex
                      justify-content-between
                      align-items-center
                      overflow-hidden
                    "
                    type="button"
                    id="dropdownDistrictButton"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <div
                      class="
                        d-flex
                        justify-content-start
                        align-items-center
                        w-100
                        py-2
                      "
                    >
                      <div class="mr-2">
                        <font-awesome-icon
                          :icon="['fas', 'filter']"
                          :class="{ 'text-primary': currentDistrict }"
                        />
                        <font-awesome-icon
                          :icon="['fas', 'check-circle']"
                          class="text-success bg-light"
                          style="
                            font-size: 0.85em;
                            position: absolute;
                            top: 1.55em;
                            right: 0.45em;
                          "
                          v-if="currentDistrict"
                        />
                      </div>
                      <div
                        class="text-left overflow-hidden w-100"
                        style="line-height: 1.3"
                      >
                        <p class="small mb-0 text-muted">District</p>
                        <p class="mb-0 text-nowrap text-truncate">
                          {{ currentDistrict ? currentDistrict.name : "All" }}
                        </p>
                      </div>
                    </div>
                  </button>
                  <div
                    class="dropdown-menu dropdown-menu-right"
                    aria-labelledby="dropdownMenuButton"
                    style="max-height: 200px; overflow-y: auto"
                  >
                    <button
                      class="
                        dropdown-item
                        font-weight-medium
                        d-flex
                        justify-content-between
                        align-items-center
                      "
                      @click="currentDistrict = null"
                    >
                      All districts
                      <font-awesome-icon
                        :icon="['fas', 'check']"
                        class="text-primary ml-3 small"
                        v-if="currentDistrict == null"
                      />
                    </button>
                    <button
                      v-for="district in userRole == 'Supervisor'
                        ? userDistricts
                        : allDistricts"
                      :key="district._id"
                      class="
                        dropdown-item
                        d-flex
                        justify-content-between
                        align-items-center
                      "
                      @click="currentDistrict = district"
                    >
                      {{ district.name }}
                      <font-awesome-icon
                        :icon="['fas', 'check']"
                        class="text-primary ml-3 small"
                        v-if="
                          currentDistrict && currentDistrict._id == district._id
                        "
                      />
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-6 px-0 border-bottom">
                <button
                  class="
                    btn btn-sm
                    text-left
                    d-flex
                    rounded-0
                    justify-content-start
                    align-items-center
                    position-relative
                    p-2
                    w-100
                    h-100
                  "
                  type="button"
                  @click="showDateSelector = true"
                >
                  <div class="mr-2">
                    <font-awesome-icon
                      :icon="['far', 'calendar-alt']"
                      :class="{ 'text-primary': dateFilter }"
                    />
                    <font-awesome-icon
                      :icon="['fas', 'check-circle']"
                      class="text-success"
                      style="
                        font-size: 0.85em;
                        position: absolute;
                        top: 1.55em;
                        right: 0.45em;
                      "
                      v-if="dateFilter"
                    />
                  </div>
                  <div class="w-100 overflow-hidden" style="line-height: 1.3">
                    <p class="small mb-0 text-muted">Date</p>
                    <p class="mb-0 text-nowrap text-truncate">
                      {{ dateFilter ? displayDateFilter : "All" }}
                    </p>
                  </div>
                </button>
              </div>
              <!-- <div class="col-6 px-0 h-100 border-right border-bottom">
                <div class="dropdown">
                  <button
                    class="
                      btn btn-sm btn-block
                      no-focus
                      dropdown-toggle
                      position-relative
                      rounded-0
                      py-0
                      px-2
                      d-flex
                      justify-content-between
                      align-items-center
                      overflow-hidden
                    "
                    type="button"
                    id="dropdownVerifiedButton"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <div
                      class="
                        d-flex
                        justify-content-start
                        align-items-center
                        w-100
                        py-2
                      "
                    >
                      <div class="mr-2">
                        <font-awesome-icon
                          :icon="['fas', 'check-double']"
                          :class="{ 'text-primary': verifiedFilter }"
                        />
                        <font-awesome-icon
                          :icon="['fas', 'check-circle']"
                          class="text-success bg-light"
                          style="
                            font-size: 0.85em;
                            position: absolute;
                            top: 1.55em;
                            right: 0.45em;
                          "
                          v-if="verifiedFilter"
                        />
                      </div>
                      <div
                        class="text-left overflow-hidden w-100"
                        style="line-height: 1.3"
                      >
                        <p class="small mb-0 text-muted">Verification</p>
                        <p class="mb-0 text-nowrap text-truncate">
                          {{ verifiedFilter ? "Verified" : "All" }}
                        </p>
                      </div>
                    </div>
                  </button>
                  <div
                    class="dropdown-menu dropdown-menu-right"
                    aria-labelledby="dropdownMenuButton"
                    style="max-height: 200px; overflow-y: auto"
                  >
                    <button
                      class="
                        dropdown-item
                        font-weight-medium
                        d-flex
                        justify-content-between
                        align-items-center
                      "
                      @click="verifiedFilter = false"
                    >
                      All
                      <font-awesome-icon
                        :icon="['fas', 'check']"
                        class="text-primary ml-3 small"
                        v-if="!verifiedFilter"
                      />
                    </button>
                    <button
                      class="
                        dropdown-item
                        d-flex
                        justify-content-between
                        align-items-center
                      "
                      @click="verifiedFilter = true"
                    >
                      Verified
                      <font-awesome-icon
                        :icon="['fas', 'check']"
                        class="text-primary ml-3 small"
                        v-if="verifiedFilter"
                      />
                    </button>
                  </div>
                </div>
              </div> -->
              <div class="col-6 px-0 h-100 border-right border-bottom">
                <div class="dropdown">
                  <button
                    class="
                      btn btn-sm btn-block
                      no-focus
                      dropdown-toggle
                      position-relative
                      rounded-0
                      py-0
                      px-2
                      d-flex
                      justify-content-between
                      align-items-center
                      overflow-hidden
                    "
                    type="button"
                    id="dropdownVerifiedButton"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <div
                      class="
                        d-flex
                        justify-content-start
                        align-items-center
                        w-100
                        py-2
                      "
                    >
                      <div class="mr-2">
                        <font-awesome-icon
                          :icon="['fas', 'check-double']"
                          :class="{ 'text-primary': statusFilter }"
                        />
                        <font-awesome-icon
                          :icon="['fas', 'check-circle']"
                          class="text-success bg-light"
                          style="
                            font-size: 0.85em;
                            position: absolute;
                            top: 1.55em;
                            right: 0.45em;
                          "
                          v-if="statusFilter"
                        />
                      </div>
                      <div
                        class="text-left overflow-hidden w-100"
                        style="line-height: 1.3"
                      >
                        <p class="small mb-0 text-muted">Status</p>
                        <p class="mb-0 text-nowrap text-truncate">
                          {{
                            statusFilter
                              ? helper.snakeToTitleCase(statusFilter)
                              : "All"
                          }}
                        </p>
                      </div>
                    </div>
                  </button>
                  <div
                    class="dropdown-menu dropdown-menu-right"
                    aria-labelledby="dropdownMenuButton"
                    style="max-height: 200px; overflow-y: auto"
                  >
                    <button
                      class="
                        dropdown-item
                        font-weight-medium
                        d-flex
                        justify-content-between
                        align-items-center
                      "
                      @click="statusFilter = null"
                    >
                      All
                      <font-awesome-icon
                        :icon="['fas', 'check']"
                        class="text-primary ml-3 small"
                        v-if="!statusFilter"
                      />
                    </button>
                    <button
                      class="
                        dropdown-item
                        d-flex
                        justify-content-between
                        align-items-center
                      "
                      @click="statusFilter = 'open'"
                    >
                      Open
                      <font-awesome-icon
                        :icon="['fas', 'check']"
                        class="text-primary ml-3 small"
                        v-if="statusFilter == 'open'"
                      />
                    </button>
                    <button
                      class="
                        dropdown-item
                        d-flex
                        justify-content-between
                        align-items-center
                      "
                      @click="statusFilter = 'closed_temporary'"
                    >
                      Closed Temporary
                      <font-awesome-icon
                        :icon="['fas', 'check']"
                        class="text-primary ml-3 small"
                        v-if="statusFilter == 'closed_temporary'"
                      />
                    </button>
                    <button
                      class="
                        dropdown-item
                        d-flex
                        justify-content-between
                        align-items-center
                      "
                      @click="statusFilter = 'closed_permanent'"
                    >
                      Closed
                      <font-awesome-icon
                        :icon="['fas', 'check']"
                        class="text-primary ml-3 small"
                        v-if="statusFilter == 'closed_permanent'"
                      />
                    </button>
                  </div>
                </div>
              </div>
              <!-- <div class="col-6 px-0 h-100 border-right border-bottom">
                <div class="dropdown">
                  <button
                    class="
                      btn btn-sm btn-block
                      no-focus
                      dropdown-toggle
                      position-relative
                      rounded-0
                      py-0
                      px-2
                      d-flex
                      justify-content-between
                      align-items-center
                      overflow-hidden
                    "
                    type="button"
                    id="dropdownVerifiedButton"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <div
                      class="
                        d-flex
                        justify-content-start
                        align-items-center
                        w-100
                        py-2
                      "
                    >
                      <div class="mr-2">
                        <font-awesome-icon
                          :icon="['fas', 'check-double']"
                          :class="{ 'text-primary': verifiedFilter }"
                        />
                        <font-awesome-icon
                          :icon="['fas', 'check-circle']"
                          class="text-success bg-light"
                          style="
                            font-size: 0.85em;
                            position: absolute;
                            top: 1.55em;
                            right: 0.45em;
                          "
                          v-if="verifiedFilter"
                        />
                      </div>
                      <div
                        class="text-left overflow-hidden w-100"
                        style="line-height: 1.3"
                      >
                        <p class="small mb-0 text-muted">Status</p>
                        <p class="mb-0 text-nowrap text-truncate">
                          {{ verifiedFilter ? "Verified" : "All" }}
                        </p>
                      </div>
                    </div>
                  </button>
                  <div
                    class="dropdown-menu dropdown-menu-right"
                    aria-labelledby="dropdownMenuButton"
                    style="max-height: 200px; overflow-y: auto"
                  >
                    <button
                      class="
                        dropdown-item
                        font-weight-medium
                        d-flex
                        justify-content-between
                        align-items-center
                      "
                      @click="verifiedFilter = false"
                    >
                      All
                      <font-awesome-icon
                        :icon="['fas', 'check']"
                        class="text-primary ml-3 small"
                        v-if="!verifiedFilter"
                      />
                    </button>
                    <button
                      class="
                        dropdown-item
                        d-flex
                        justify-content-between
                        align-items-center
                      "
                      @click="verifiedFilter = true"
                    >
                      Verified
                      <font-awesome-icon
                        :icon="['fas', 'check']"
                        class="text-primary ml-3 small"
                        v-if="verifiedFilter"
                      />
                    </button>
                  </div>
                </div>
              </div> -->
              <!-- <div class="col-6 px-0 border-bottom border-right">
                <div class="dropdown">
                  <button
                    class="
                      btn btn-sm btn-block
                      dropdown-toggle
                      no-focus
                      position-relative
                      rounded-0
                      py-0
                      px-2
                      d-flex
                      justify-content-between
                      align-items-center
                      overflow-hidden
                    "
                    type="button"
                    id="dropdownScopeButton"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <div
                      class="
                        d-flex
                        justify-content-start
                        align-items-center
                        w-100
                        py-2
                      "
                    >
                      <div class="mr-2">
                        <font-awesome-icon
                          :icon="['fas', 'file-signature']"
                          :class="{ 'text-primary': workScopeFilter }"
                        />
                        <font-awesome-icon
                          :icon="['fas', 'check-circle']"
                          class="text-success bg-light"
                          style="
                            font-size: 0.85em;
                            position: absolute;
                            top: 1.55em;
                            right: 0.45em;
                          "
                          v-if="workScopeFilter"
                        />
                      </div>
                      <div
                        class="text-left overflow-hidden w-100"
                        style="line-height: 1.3"
                      >
                        <p class="small mb-0 text-muted">Work Scope</p>
                        <p class="mb-0 text-nowrap text-truncate">
                          {{ workScopeFilter ? workScopeFilter : "All" }}
                        </p>
                      </div>
                    </div>
                  </button>
                  <div
                    class="dropdown-menu dropdown-menu-right"
                    aria-labelledby="dropdownMenuButton"
                    style="max-height: 200px; overflow-y: auto"
                  >
                    <button
                      class="
                        dropdown-item
                        font-weight-medium
                        d-flex
                        justify-content-between
                        align-items-center
                      "
                      @click="workScopeFilter = null"
                    >
                      All scopes
                      <font-awesome-icon
                        :icon="['fas', 'check']"
                        class="text-primary ml-3 small"
                        v-if="workScopeFilter == null"
                      />
                    </button>
                    <button
                      v-for="scope in workScopes"
                      :key="`scope-${scope}`"
                      class="
                        dropdown-item
                        d-flex
                        justify-content-between
                        align-items-center
                      "
                      @click="workScopeFilter = scope"
                    >
                      {{ scope }}
                      <font-awesome-icon
                        :icon="['fas', 'check']"
                        class="text-primary ml-3 small"
                        v-if="workScopeFilter == scope"
                      />
                    </button>
                  </div>
                </div>
              </div> -->
            </div>
            <div class="input-group mb-0 border-top shadow-sm">
              <!-- <input
                type="text"
                style="display: none;"
                class="form-control border-0"
                placeholder="Search by case number"
                v-model="search"
                @keydown.enter="searchByCaseNumber(search)"
              /> -->
              <!-- <input
                autofill="off" 
                autocomplete="off"
                type="text"
                class="form-control border-0"
                placeholder="Search by case number"
                v-model="search"
                @keydown.enter="searchByCaseNumber(search)"
              /> -->
              <!-- <div class="input-group-append">
                <button
                  class="btn ps-0"
                  v-if="search.length > 0"
                  @click="searchByCaseNumber('')"
                >
                  <span>&times;</span>
                </button>
                <button
                  class="btn btn-light rounded-0 border-left px-3"
                  @click="searchByCaseNumber(search)"
                >
                  <font-awesome-icon :icon="['fas', 'search']" />
                </button>
              </div> -->
            </div>
          </div>

          <div
            class="case-body has-filter rounded-0 shadow-none"
            style="height: calc(100% - 141px)"
          >
            <div ref="caseList" class="projects-list-container h-100">
              <div
                class="case-list position-relative hover-parent"
                v-for="cse in cases"
                :key="cse._id"
                :id="cse._id"
                :class="{ active: currentCase == cse }"
                @click="goTo(cse._id)"
              >
                <p class="font-weight-bold mb-0">
                  #{{ cse.index }}
                  &middot;
                  {{ helper.formatDate(cse.timestamp) }}
                </p>
                <span
                  class="badge badge-pill"
                  :class="{
                    'badge-primary': cse.status == 'solved',
                    'badge-success': cse.status == 'solvedPermanent',
                    'badge-danger':
                      cse.status == 'received' || cse.status == 'inProgress',
                  }"
                  >{{
                    cse.status == "solved"
                      ? "Closed Temporary"
                      : cse.status == "solvedPermanent"
                      ? "Closed"
                      : "Open"
                  }}</span
                >
                <span
                  class="badge badge-warning badge-pill ml-2"
                  v-show="
                    cse.media_during.length > 0 &&
                    cse.media_after.length > 0 &&
                    cse.status != 'solved' &&
                    cse.status != 'solvedPermanent'
                  "
                  >Need Verification
                </span>

                <!-- <p class="small text-muted mb-0 text-nowrap text-truncate">
                  <strong>Case Number</strong> {{ cse.caseNumber }}
                </p> -->
                <p
                  class="small text-muted mb-0 text-nowrap text-truncate"
                  v-if="cse.road"
                >
                  {{
                    helper.getRoadInfo({
                      name: cse.road.name,
                      district:
                        getDistrictName(cse.road.daerah) || cse.road.district,
                    })
                  }}
                </p>
                <p
                  class="small text-muted mb-0 text-nowrap text-truncate"
                  v-if="cse.lat && cse.lng"
                >
                  [{{ helper.formatCoordinate([cse.lat, cse.lng]) }}]
                </p>
                <button
                  class="btn btn-sm btn-danger position-absolute hover-item"
                  style="top: 1rem; right: 1rem"
                  @click.stop="deleteCase(cse)"
                >
                  <font-awesome-icon :icon="['fas', 'trash-alt']" />
                </button>
              </div>
              <div
                class="p-4 d-flex justify-content-center align-items-center"
                v-if="cases.length > 0"
              >
                <p class="mb-0 font-italic text-muted">
                  End of
                  {{
                    currentPage == totalPage ? "list" : `page ${currentPage}`
                  }}
                </p>
              </div>
              <div
                class="p-4 d-flex justify-content-center align-items-center"
                v-else
              >
                <p class="mb-0 font-italic text-muted">No case found</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col section-right text-truncate d-flex px-0 px-md-3">
        <div class="case-container bg-gradient w-100">
          <div class="section-header">
            <button
              class="
                btn btn-outline-primary
                shadow-sm
                mr-3
                section-left-toggler
              "
              @click="toggleSidebar()"
            >
              <font-awesome-icon :icon="['fas', 'angle-right']" />
            </button>
            <div
              v-if="currentCase"
              class="
                w-100
                d-flex
                flex-column flex-sm-row
                justify-content-between
                align-items-start align-items-sm-center
              "
            >
              <div class="d-flex align-items-center">
                <!-- <font-awesome-icon
                  :icon="['fas', 'hard-hat']"
                  class="mr-3 text-primary fa-2x d-none d-sm-block"
                /> -->
                <div>
                  <div
                    class="text-uppercase text-nowrap d-flex align-items-center"
                  >
                    #{{ currentCase.index }}
                    &middot;
                    {{ helper.formatDate(currentCase.timestamp) }}
                    <button
                      class="btn btn-edit p-0 btn-sm"
                      @click="editCase(currentCase)"
                    >
                      <font-awesome-icon
                        :icon="['far', 'edit']"
                        class="ml-2 text-primary"
                      />
                    </button>
                  </div>
                  <p
                    class="
                      text-muted
                      mb-0
                      small
                      d-none d-sm-block
                      text-nowrap text-truncate
                    "
                  >
                    <template v-if="currentCase.road">
                      {{
                        helper.getRoadInfo({
                          name: currentCase.road.name,
                          district:
                            getDistrictName(currentCase.road.daerah) ||
                            currentCase.road.district,
                        })
                      }}
                    </template>
                  </p>
                </div>
              </div>
              <div
                class="
                  pl-0 pl-sm-2
                  d-flex
                  flex-column
                  align-items-sm-end
                  justify-content-center
                  align-items-start
                "
              >
                <small class="text-muted text-nowrap text-truncate">
                  <strong>Case Number</strong> {{ currentCase.caseNumber }}
                </small>
                <a
                  v-if="!isNaN(currentCase.lat) && !isNaN(currentCase.lng)"
                  class="small"
                  :href="`https://www.google.com/maps/place/${currentCase.lat}, ${currentCase.lng}`"
                  target="_blank"
                >
                  <font-awesome-icon
                    :icon="['fas', 'map-marker-alt']"
                    class="mr-1"
                  />
                  {{
                    helper.formatCoordinate([currentCase.lat, currentCase.lng])
                  }}
                </a>
              </div>
            </div>
            <p
              v-else
              class="
                font-weight-normal
                small
                mb-0
                font-italic
                flex-grow-1
                text-center
              "
            >
              No case selected
            </p>
          </div>
          <div ref="reportBody" class="report-body w-100" v-if="currentCase">
            <div
              class="case-map"
              :style="
                currentCase.lat !== null && currentCase.lng !== null
                  ? ''
                  : 'height: 0px'
              "
            >
              <div id="map"></div>
              <Pin
                :key="casePin._id"
                :map="map"
                :caseItem="casePin"
                v-if="casePin"
              />
            </div>
            <div class="w-100 d-flex border-bottom justify-content-between">
              <div class="px-3 pb-3">
                <span class="badge badge-dark badge-pill mb-2">Caption</span>
                <p class="mb-0 small">{{ currentCase.caption }}</p>
              </div>
              <div class="px-3 pb-3">
                <button
                  class="btn btn-link text-decoration-none"
                  @click="permanentClick"
                >
                  <font-awesome-icon
                    :icon="['fas', 'check-circle']"
                    class="text-primary mr-1"
                    v-if="currentCase.isPermanent"
                  />
                  <font-awesome-icon
                    :icon="['far', 'circle']"
                    class="text-primary mr-1"
                    v-else
                  />
                  Tampalan Kekal
                </button>
              </div>
            </div>

            <div class="row m-0">
              <div class="col-12 col-lg-6 border-right">
                <div
                  class="
                    d-flex
                    justify-content-between
                    align-items-center
                    px-3
                    pt-3
                  "
                >
                  <h5 class="mb-2">Sementara</h5>
                  <template
                    v-if="
                      currentCase.media_during &&
                      currentCase.media_during.length > 0 &&
                      currentCase.media_after &&
                      currentCase.media_after.length > 0
                    "
                  >
                    <div
                      class="btn btn-success btn-sm disabled opacity-1"
                      v-if="
                        ['solved', 'solvedPermanent'].includes(
                          currentCase.status
                        )
                      "
                    >
                      <font-awesome-icon
                        :icon="['fas', 'check-circle']"
                        class="mr-1"
                      />
                      <small>Tindakan selesai</small>
                    </div>
                    <button
                      class="btn btn-primary btn-sm"
                      @click="setAsClose('solved')"
                      v-else
                    >
                      <small>Tanda sebagai selesai</small>
                    </button>
                  </template>
                </div>

                <div class="case-before p-3">
                  <div
                    class="
                      d-flex
                      justify-content-between
                      align-items-center
                      mb-3
                    "
                  >
                    <p class="small mb-0">
                      <font-awesome-icon
                        :icon="['far', 'calendar-alt']"
                        class="mr-1"
                      />
                      Completed on
                    </p>
                    <p class="small mb-0">
                      <span class="font-weight-medium">
                        {{
                          currentCase.solveDate
                            ? moment
                                .unix(currentCase.solveDate)
                                .format("DD MMM YYYY h:mm A")
                            : "----"
                        }}
                      </span>
                      <button
                        class="btn btn-sm p-0"
                        @click="editSolveDate()"
                        v-if="currentCase.solveDate"
                      >
                        <font-awesome-icon
                          :icon="['far', 'edit']"
                          class="ml-1"
                        />
                      </button>
                    </p>
                  </div>
                  <p
                    class="
                      font-weight-medium
                      mb-2
                      badge badge-secondary badge-pill
                      px-2
                    "
                  >
                    Sebelum
                  </p>
                  <div class="media-grid no-pseudo w-100">
                    <div v-for="media in currentCase.media" :key="media._id">
                      <div class="img-container">
                        <img
                          :src="helper.formatMediaUrl(media)"
                          @click="currentMedia = media"
                        />
                      </div>
                      <button
                        class="btn btn-sm btn-delete"
                        @click="deleteImage('before', media._id)"
                        v-if="currentCase.media.length > 1"
                      >
                        <font-awesome-icon :icon="['fas', 'trash-alt']" />
                      </button>
                    </div>
                    <div>
                      <div
                        class="
                          h-100
                          w-100
                          clickable
                          d-flex
                          flex-column
                          justify-content-center
                          align-items-center
                          bg-light
                          border-dashed
                          rounded
                        "
                        @click="addImage('before')"
                      >
                        <span class="fa-stack fa-2x">
                          <font-awesome-icon
                            :icon="['fas', 'image']"
                            class="fa-stack-2x semi-transparent text-muted"
                          />
                          <font-awesome-icon
                            :icon="['fas', 'plus']"
                            class="fa-stack-1x"
                            style="font-size: 20px"
                          />
                        </span>
                        <small class="text-muted mt-1">
                          Add
                          <pre class="d-inline">Before</pre>
                          picture
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="case-during p-3">
                  <p
                    class="
                      font-weight-medium
                      mb-2
                      badge badge-info badge-pill
                      px-2
                    "
                  >
                    Semasa
                  </p>
                  <div class="media-grid no-pseudo">
                    <div
                      :key="file._id"
                      v-for="file in currentCase.media_during"
                    >
                      <div class="img-container">
                        <img
                          :src="helper.formatMediaUrl(file)"
                          @click="currentMedia = file"
                        />
                      </div>
                      <button
                        class="btn btn-sm btn-delete"
                        @click="deleteImage('during', file._id)"
                      >
                        <font-awesome-icon :icon="['fas', 'trash-alt']" />
                      </button>
                    </div>
                    <div>
                      <div
                        class="
                          h-100
                          w-100
                          clickable
                          d-flex
                          flex-column
                          justify-content-center
                          align-items-center
                          bg-light
                          border-dashed
                          rounded
                        "
                        @click="addImage('during')"
                      >
                        <span class="fa-stack fa-2x">
                          <font-awesome-icon
                            :icon="['fas', 'image']"
                            class="fa-stack-2x semi-transparent text-muted"
                          />
                          <font-awesome-icon
                            :icon="['fas', 'plus']"
                            class="fa-stack-1x"
                            style="font-size: 20px"
                          />
                        </span>
                        <small class="text-muted mt-1">
                          Add
                          <pre class="d-inline">During</pre>
                          picture
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="case-after p-3">
                  <p
                    class="
                      font-weight-medium
                      mb-2
                      badge badge-primary badge-pill
                      px-2
                    "
                  >
                    Selepas
                  </p>
                  <div class="small rounded bg-light border p-2 mb-3">
                    <p
                      class="
                        text-muted
                        font-weight-medium
                        mb-1
                        d-flex
                        justify-content-between
                        align-items-center
                      "
                    >
                      Tindakan Diambil
                      <button
                        class="btn btn-sm text-primary p-0"
                        @click="isEditingAfterCaption = true"
                      >
                        <font-awesome-icon :icon="['far', 'edit']" />
                      </button>
                    </p>
                    <template v-if="isEditingAfterCaption">
                      <textarea
                        rows="5"
                        class="
                          form-control form-control-default form-control-sm
                        "
                        style="resize: none"
                        v-model="afterCaptionModel"
                      ></textarea>
                      <div
                        class="
                          d-flex
                          justify-content-between
                          align-items-center
                          mt-3
                        "
                      >
                        <button
                          class="btn btn-sm btn-light"
                          @click="cancelEditAfterCaption()"
                        >
                          Cancel
                        </button>
                        <button
                          class="btn btn-sm btn-primary"
                          @click="saveAfterCaption()"
                        >
                          Save
                        </button>
                      </div>
                    </template>
                    <p class="mb-0" v-else>
                      <span v-if="currentCase.afterCaption">
                        {{ currentCase.afterCaption }}
                      </span>
                      <span v-else class="font-italic">No note</span>
                    </p>
                  </div>
                  <div class="media-grid no-pseudo">
                    <div
                      :key="file._id"
                      v-for="file in currentCase.media_after"
                    >
                      <div class="img-container">
                        <img
                          :src="helper.formatMediaUrl(file)"
                          @click="currentMedia = file"
                        />
                      </div>
                      <button
                        class="btn btn-sm btn-delete"
                        @click="deleteImage('after', file._id)"
                      >
                        <font-awesome-icon :icon="['fas', 'trash-alt']" />
                      </button>
                    </div>
                    <div>
                      <div
                        class="
                          h-100
                          w-100
                          clickable
                          d-flex
                          flex-column
                          justify-content-center
                          align-items-center
                          bg-light
                          rounded
                          border-dashed
                        "
                        @click="addImage('after')"
                      >
                        <span class="fa-stack fa-2x">
                          <font-awesome-icon
                            :icon="['fas', 'image']"
                            class="fa-stack-2x semi-transparent text-muted"
                          />
                          <font-awesome-icon
                            :icon="['fas', 'plus']"
                            class="fa-stack-1x"
                            style="font-size: 20px"
                          />
                        </span>
                        <small class="text-muted mt-1">
                          Add
                          <pre class="d-inline">After</pre>
                          picture
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 col-lg-6" v-if="currentCase.isPermanent">
                <div
                  class="
                    d-flex
                    justify-content-between
                    align-items-center
                    px-3
                    pt-3
                  "
                >
                  <h5 class="mb-2">KEKAL</h5>
                  <template
                    v-if="
                      currentCase.media_during_permanent &&
                      currentCase.media_during_permanent.length > 0 &&
                      currentCase.media_after_permanent &&
                      currentCase.media_after_permanent.length > 0
                    "
                  >
                    <div
                      class="btn btn-success btn-sm disabled opacity-1"
                      v-if="currentCase.status == 'solvedPermanent'"
                    >
                      <font-awesome-icon
                        :icon="['fas', 'check-circle']"
                        class="mr-1"
                      />
                      <small>Tindakan selesai</small>
                    </div>
                    <button
                      class="btn btn-primary btn-sm"
                      @click="setAsClose('solvedPermanent')"
                      v-else
                    >
                      <small>Tanda sebagai selesai</small>
                    </button>
                  </template>
                </div>
                <!-- <div class="d-flex justify-content-between align-items-center">
                  <select
                    id="selectContractor"
                    class="custom-select"
                    v-model="currentCase.contractor"
                  >
                    <option :value="null" disabled>Select Contractor</option>
                    <option
                      v-for="contractor in contractors"
                      :key="contractor._id"
                      :value="contractor"
                    >
                      {{ contractor.name }}
                    </option>
                  </select>
                </div> -->
                <div class="case-before p-3">
                  <div
                    class="
                      d-flex
                      justify-content-between
                      align-items-center
                      mb-3
                    "
                  >
                    <p class="small mb-0">
                      <font-awesome-icon
                        :icon="['far', 'calendar-alt']"
                        class="mr-1"
                      />
                      Completed on
                    </p>
                    <p class="small mb-0">
                      <span class="font-weight-medium">
                        {{
                          currentCase.solveDatePermanent
                            ? moment
                                .unix(currentCase.solveDatePermanent)
                                .format("DD MMM YYYY h:mm A")
                            : "----"
                        }}
                      </span>
                      <button
                        class="btn btn-sm p-0"
                        @click="editSolveDate()"
                        v-if="currentCase.solveDatePermanent"
                      >
                        <font-awesome-icon
                          :icon="['far', 'edit']"
                          class="ml-1"
                        />
                      </button>
                    </p>
                  </div>
                  <p
                    class="
                      font-weight-medium
                      mb-2
                      badge badge-secondary badge-pill
                      px-2
                    "
                  >
                    Sebelum - Kekal
                  </p>
                  <div class="media-grid no-pseudo w-100">
                    <div
                      v-for="media in currentCase.media_after.length
                        ? currentCase.media_after
                        : currentCase.media"
                      :key="media._id"
                    >
                      <div class="img-container">
                        <img
                          :src="helper.formatMediaUrl(media)"
                          @click="currentMedia = media"
                        />
                      </div>
                      <button
                        class="btn btn-sm btn-delete"
                        @click="
                          deleteImage(
                            currentCase.media_after ? 'media_after' : 'media',
                            media._id
                          )
                        "
                        v-if="currentCase.media.length > 1"
                      >
                        <font-awesome-icon :icon="['fas', 'trash-alt']" />
                      </button>
                    </div>
                    <div>
                      <div
                        class="
                          h-100
                          w-100
                          clickable
                          d-flex
                          flex-column
                          justify-content-center
                          align-items-center
                          bg-light
                          border-dashed
                          rounded
                        "
                        @click="
                          addImage(
                            currentCase.media_after ? 'media_after' : 'media'
                          )
                        "
                      >
                        <span class="fa-stack fa-2x">
                          <font-awesome-icon
                            :icon="['fas', 'image']"
                            class="fa-stack-2x semi-transparent text-muted"
                          />
                          <font-awesome-icon
                            :icon="['fas', 'plus']"
                            class="fa-stack-1x"
                            style="font-size: 20px"
                          />
                        </span>
                        <small class="text-muted mt-1">
                          Add
                          <pre class="d-inline">Before</pre>
                          picture
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="case-during p-3">
                  <p
                    class="
                      font-weight-medium
                      mb-2
                      badge badge-info badge-pill
                      px-2
                    "
                  >
                    Semasa - Kekal
                  </p>
                  <div class="media-grid no-pseudo">
                    <div
                      :key="file._id"
                      v-for="file in currentCase.media_during_permanent"
                    >
                      <div class="img-container">
                        <img
                          :src="helper.formatMediaUrl(file)"
                          @click="currentMedia = file"
                        />
                      </div>
                      <button
                        class="btn btn-sm btn-delete"
                        @click="deleteImage('during_permanent', file._id)"
                      >
                        <font-awesome-icon :icon="['fas', 'trash-alt']" />
                      </button>
                    </div>
                    <div>
                      <div
                        class="
                          h-100
                          w-100
                          clickable
                          d-flex
                          flex-column
                          justify-content-center
                          align-items-center
                          bg-light
                          border-dashed
                          rounded
                        "
                        @click="addImage('during_permanent')"
                      >
                        <span class="fa-stack fa-2x">
                          <font-awesome-icon
                            :icon="['fas', 'image']"
                            class="fa-stack-2x semi-transparent text-muted"
                          />
                          <font-awesome-icon
                            :icon="['fas', 'plus']"
                            class="fa-stack-1x"
                            style="font-size: 20px"
                          />
                        </span>
                        <small class="text-muted mt-1">
                          Add
                          <pre class="d-inline">During</pre>
                          picture
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="case-after p-3">
                  <p
                    class="
                      font-weight-medium
                      mb-2
                      badge badge-primary badge-pill
                      px-2
                    "
                  >
                    Selepas - Kekal
                  </p>
                  <div class="small rounded bg-light border p-2 mb-3">
                    <p
                      class="
                        text-muted
                        font-weight-medium
                        mb-1
                        d-flex
                        justify-content-between
                        align-items-center
                      "
                    >
                      Tindakan Diambil
                      <button
                        class="btn btn-sm text-primary p-0"
                        @click="isEditingAfterCaption = true"
                      >
                        <font-awesome-icon :icon="['far', 'edit']" />
                      </button>
                    </p>
                    <template v-if="isEditingAfterCaption">
                      <textarea
                        rows="5"
                        class="
                          form-control form-control-default form-control-sm
                        "
                        style="resize: none"
                        v-model="afterCaptionModel"
                      ></textarea>
                      <div
                        class="
                          d-flex
                          justify-content-between
                          align-items-center
                          mt-3
                        "
                      >
                        <button
                          class="btn btn-sm btn-light"
                          @click="cancelEditAfterCaption()"
                        >
                          Cancel
                        </button>
                        <button
                          class="btn btn-sm btn-primary"
                          @click="saveAfterCaption()"
                        >
                          Save
                        </button>
                      </div>
                    </template>
                    <p class="mb-0" v-else>
                      <span v-if="currentCase.afterCaption">
                        {{ currentCase.afterCaption }}
                      </span>
                      <span v-else class="font-italic">No note</span>
                    </p>
                  </div>
                  <div class="media-grid no-pseudo">
                    <div
                      :key="file._id"
                      v-for="file in currentCase.media_after_permanent"
                    >
                      <div class="img-container">
                        <img
                          :src="helper.formatMediaUrl(file)"
                          @click="currentMedia = file"
                        />
                      </div>
                      <button
                        class="btn btn-sm btn-delete"
                        @click="deleteImage('after_permanent', file._id)"
                      >
                        <font-awesome-icon :icon="['fas', 'trash-alt']" />
                      </button>
                    </div>
                    <div>
                      <div
                        class="
                          h-100
                          w-100
                          clickable
                          d-flex
                          flex-column
                          justify-content-center
                          align-items-center
                          bg-light
                          rounded
                          border-dashed
                        "
                        @click="addImage('after_permanent')"
                      >
                        <span class="fa-stack fa-2x">
                          <font-awesome-icon
                            :icon="['fas', 'image']"
                            class="fa-stack-2x semi-transparent text-muted"
                          />
                          <font-awesome-icon
                            :icon="['fas', 'plus']"
                            class="fa-stack-1x"
                            style="font-size: 20px"
                          />
                        </span>
                        <small class="text-muted mt-1">
                          Add
                          <pre class="d-inline">After</pre>
                          picture
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="col-12 col-lg-6">
                <div class="case-verification py-3 pl-3 pl-lg-0 pr-3">
                  <p
                    class="
                      font-weight-medium
                      mb-2
                      badge badge-success badge-pill
                      px-2
                    "
                  >
                    Verifications
                  </p>
                  <div
                    class="card border bg-light mb-4"
                    v-for="verification in sortedVerifications"
                    :key="verification._id"
                  >
                    <div class="card-body">
                      <button
                        class="btn btn-sm btn-delete"
                        @click="deleteVerification(verification._id)"
                        v-if="currentCase.media.length > 1"
                      >
                        <font-awesome-icon :icon="['fas', 'trash-alt']" />
                      </button>
                      <p class="small text-muted font-weight-medium mb-2">
                        <font-awesome-icon
                          :icon="['far', 'calendar-alt']"
                          class="mr-2"
                        />
                        {{ helper.formatDate(verification.datetime, true) }}
                      </p>
                      <p class="small text-muted font-weight-medium">
                        <font-awesome-icon
                          :icon="['far', 'sticky-note']"
                          class="mr-2"
                        />
                        {{ verification.remarks }}
                      </p>
                      <div class="media-grid no-pseudo">
                        <div v-for="file in verification.media" :key="file._id">
                          <div class="img-container">
                            <img
                              :src="helper.formatMediaUrl(file)"
                              @click="currentMedia = file"
                            />
                          </div>
                          <button
                            class="btn btn-sm btn-delete"
                            @click="
                              deleteImage(
                                'verification',
                                file._id,
                                verification._id
                              )
                            "
                          >
                            <font-awesome-icon :icon="['fas', 'trash-alt']" />
                          </button>
                        </div>
                        <div>
                          <div
                            class="
                              h-100
                              w-100
                              clickable
                              d-flex
                              flex-column
                              justify-content-center
                              align-items-center
                              bg-light
                              rounded
                              border-dashed
                            "
                            @click="addImage('verification', verification._id)"
                          >
                            <span class="fa-stack fa-2x">
                              <font-awesome-icon
                                :icon="['fas', 'image']"
                                class="fa-stack-2x semi-transparent text-muted"
                              />
                              <font-awesome-icon
                                :icon="['fas', 'plus']"
                                class="fa-stack-1x"
                                style="font-size: 20px"
                              />
                            </span>
                            <small class="text-muted mt-1">Add picture</small>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="card border-dashed bg-light clickable"
                    @click="addingVerification = true"
                  >
                    <div
                      class="
                        card-body
                        d-flex
                        flex-column
                        justify-content-center
                        align-items-center
                      "
                    >
                      <font-awesome-icon
                        :icon="['fas', 'plus']"
                        style="font-size: 25px"
                      />
                      <small class="text-muted mt-1">
                        Add new verification
                      </small>
                    </div>
                  </div>
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <spinner v-if="isProcessing" />
    <media-preview
      v-if="currentMedia"
      :url="helper.formatMediaUrl(currentMedia)"
      @close="currentMedia = null"
    />
    <date-selector
      v-if="showDateSelector"
      :dateRange="dateFilter"
      :isRange="true"
      @close="dateSelected"
    />
    <date-time-selector
      v-if="showDateTimeSelector"
      :date="dateTimeValue"
      @close="dateTimeSelected"
    />
    <edit-case-modal
      :show="editingCase"
      :currentCase="currentCase"
      :districts="userRole == 'Supervisor' ? userDistricts : allDistricts"
      :contractors="contractors"
      :roads="
        allDistricts
          ? allDistricts.map((district) => district.roads).flat()
          : []
      "
      @close="closeEditCase"
    />
    <!-- <add-case-verification-modal
      :show="addingVerification"
      :currentCase="currentCase"
      @close="closeAddVerification"
    /> -->
  </div>
</template>

<script>
import "mapbox-gl";
import API from "@/api";
import Moment from "moment";
import Helper from "@/helper";
import Swal from "sweetalert2";
import Pin from "@/components/Pin";
import Spinner from "@/components/Spinner";
import DateSelector from "@/components/DateSelector";
import DateTimeSelector from "@/components/DateTimeSelector";
import EditCaseModal from "@/modals/EditCase.vue";
// import AddCaseVerificationModal from "@/modals/AddCaseVerification.vue";
import MediaPreview from "@/components/MediaPreview";

export default {
  name: "cases",
  components: {
    Pin,
    Spinner,
    MediaPreview,
    DateSelector,
    DateTimeSelector,
    EditCaseModal,
    // AddCaseVerificationModal,
  },
  data() {
    return {
      moment: Moment,
      map: null,
      casePin: null,
      helper: Helper,
      isProcessing: false,
      isEditingAfterCaption: false,
      afterCaptionModel: null,
      showSidebar: false,
      cases: [],
      allDistricts: [],
      currentCase: null,
      casesCount: 0,
      currentPage: 1,
      pageLimit: 100,
      totalPage: 1,
      inputPage: 1,
      currentMedia: null,
      editingCase: null,
      userDistricts: [],
      userRole: null,
      currentDistrict: null,
      dateFilter: null,
      showDateSelector: false,
      showDateTimeSelector: false,
      dateTimeValue: null,
      verifiedFilter: false,
      workScopeFilter: null,
      contractorFilter: null,
      statusFilter: null,
      workScopes: ["RI", "R01"],
      addingVerification: false,
      search: "",
      contractors: [],
    };
  },
  watch: {
    currentDistrict: {
      handler() {
        this.changePage(1, true);
      },
      immediate: false,
    },
    statusFilter: {
      handler() {
        this.changePage(1, true);
      },
      immediate: false,
    },
    verifiedFilter: {
      handler() {
        this.changePage(1, true);
      },
      immediate: false,
    },
    workScopeFilter: {
      handler() {
        this.changePage(1, true);
      },
      immediate: false,
    },
    contractorFilter: {
      handler() {
        this.changePage(1, true);
      },
      immediate: false,
    },
  },
  computed: {
    sortedVerifications() {
      let verifications = this.currentCase.verifications
        ? JSON.parse(JSON.stringify(this.currentCase.verifications))
        : [];

      return verifications.sort((a, b) => {
        let aDatetime = Moment(a.datetime).unix();
        let bDatetime = Moment(b.datetime).unix();

        return aDatetime - bDatetime;
      });
    },
    displayDateFilter() {
      if (this.dateFilter) {
        if (this.dateFilter.start == this.dateFilter.end) {
          return Moment(this.dateFilter.start).format("D MMM YYYY");
        } else if (
          Moment(this.dateFilter.start).format("MM-YYYY") ==
          Moment(this.dateFilter.end).format("MM-YYYY")
        ) {
          return `${Moment(this.dateFilter.start).format("D")} - ${Moment(
            this.dateFilter.end
          ).format("D MMM YYYY")}`;
        } else if (
          Moment(this.dateFilter.start).format("YYYY") ==
          Moment(this.dateFilter.end).format("YYYY")
        ) {
          return `${Moment(this.dateFilter.start).format("D MMM")} - ${Moment(
            this.dateFilter.end
          ).format("D MMM YYYY")}`;
        } else {
          return `${Moment(this.dateFilter.start).format(
            "D MMM YYYY"
          )} - ${Moment(this.dateFilter.end).format("D MMM YYYY")}`;
        }
      } else {
        return null;
      }
    },
  },
  methods: {
    async dateTimeSelected(e) {
      const caseStatus = JSON.parse(JSON.stringify(this.showDateTimeSelector));

      this.showDateTimeSelector = null;

      if (e) {
        const body = {};

        if (caseStatus.includes("solved")) {
          body["status"] = caseStatus;
        }

        body[
          this.currentCase.isPermanent ? "solveDatePermanent" : "solveDate"
        ] = Moment(e).unix();

        this.$emit("isLoading", true);

        let res = await API.put(`cases/${this.currentCase._id}`, body);

        const caseIndex = this.cases.findIndex(
          (c) => c._id == this.currentCase._id
        );

        this.$emit("isLoading", false);

        if (caseIndex > -1) {
          this.currentCase = res.data;

          this.$set(this.cases, caseIndex, this.currentCase);

          Swal.fire("Aduan berjaya dikemaskini", "", "success");
        } else {
          Swal.fire("Invalid case ID", "", "error");
        }
      }
    },
    editSolveDate() {
      this.dateTimeValue = new Date();

      this.showDateTimeSelector = "true";
    },
    setAsClose(status) {
      if (!this.currentCase || status == this.currentCase.status) return;

      Swal.fire({
        title: "Tandakan aduan sebagai SELESAI?",
        icon: "question",
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonText: "Ya",
        cancelButtonText: "Tidak",
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.dateTimeValue = new Date();

          this.showDateTimeSelector = status;
        }
      });
    },
    permanentClick() {
      Swal.fire({
        title: this.currentCase.isPermanent
          ? "Set sebagai Tampalan Sementara?"
          : "Set sebagai Tampalan Kekal?",
        icon: "question",
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonText: "Yes",
      }).then(async (result) => {
        if (result.isConfirmed) {
          let res = await API.put(`cases/${this.currentCase._id}`, {
            isPermanent: !this.currentCase.isPermanent,
          });

          const caseIndex = this.cases.findIndex(
            (c) => c._id == this.currentCase._id
          );
          if (caseIndex > -1) {
            this.$set(this.cases, caseIndex, this.currentCase);

            this.currentCase = res.data;

            Swal.fire("Aduan berjaya dikemaskini", "", "success");
          } else {
            Swal.fire("Invalid case ID", "", "error");
          }
        }
      });
    },
    async saveAfterCaption() {
      if (this.currentCase) {
        this.isProcessing = true;

        const { data } = await API.put(`cases/${this.currentCase._id}`, {
          afterCaption: this.afterCaptionModel,
        });

        this.isProcessing = false;

        if (data) {
          let _case = this.cases.find((c) => c._id == data._id);

          if (_case) {
            _case.afterCaption = data.afterCaption;
          }

          Swal.fire("Tindakan Diambil berjaya disimpan", "", "success");
        }
      }

      this.isEditingAfterCaption = false;
    },
    cancelEditAfterCaption() {
      this.isEditingAfterCaption = false;

      this.afterCaptionModel = this.currentCase.afterCaption;
    },
    async deleteCase(_case) {
      Swal.fire({
        title: "Delete this case?",
        icon: "question",
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonText: "Yes",
      }).then(async (result) => {
        if (result.isConfirmed) {
          await API.delete(`cases/${_case._id}`);

          this.cases = this.cases.filter((cse) => cse._id != _case._id);

          if (this.currentCase && this.currentCase._id == _case._id) {
            this.currentCase = null;
          }

          Swal.fire("Case deleted", "", "success");
        }
      });
    },
    searchByCaseNumber(search) {
      if (this.$route.params.id != search) {
        this.search = search;

        let params = {
          id: search || null,
        };

        this.$router.replace({
          params: params,
        });
      }

      this.changePage(1, true);
    },
    deleteVerification(id) {
      Swal.fire({
        html: "Confirm delete verification?",
        icon: "question",
        confirmButtonText: "Confirm",
        showCancelButton: true,
        buttonsStyling: false,
        reverseButtons: true,
        customClass: {
          confirmButton: "btn btn-sm btn-danger",
          cancelButton: "btn btn-sm btn-link",
          actions: "d-flex justify-content-between align-items-center",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          this.isProcessing = true;

          API.delete(`verifications/${id}`)
            .then(() => {
              this.isProcessing = false;

              const caseIndex = this.cases.findIndex(
                (c) => c._id == this.currentCase._id
              );

              if (caseIndex > -1) {
                this.currentCase.verifications =
                  this.currentCase.verifications.filter((v) => v._id != id);
              }

              Swal.fire("", "Verification deleted", "success");
            })
            .catch((err) => {
              this.isProcessing = false;

              console.error(err);

              Swal.fire("", "Error deleting verification", "error");
            });
        }
      });
    },
    closeAddVerification(response) {
      this.addingVerification = false;

      if (response) {
        const caseIndex = this.cases.findIndex(
          (c) => c._id == this.currentCase._id
        );

        if (caseIndex > -1) {
          if (!this.currentCase.verifications) {
            this.currentCase.verifications = [];
          }

          const verificationIndex = this.currentCase.verifications.findIndex(
            (c) => c._id == response._id
          );

          if (verificationIndex > -1) {
            this.currentCase.verifications[verificationIndex] = response;
          } else {
            this.currentCase.verifications.push(response);
          }

          this.$set(this.cases, caseIndex, this.currentCase);

          Swal.fire("Verification added", "", "success");
        } else {
          Swal.fire("Invalid case ID", "", "error");
        }
      }
    },
    dateSelected(e) {
      if (typeof e == "object") {
        this.dateFilter = {
          start: Moment(e.start).format("YYYY-MM-DD"),
          end: Moment(e.end).format("YYYY-MM-DD"),
        };

        this.changePage(1, true);
      } else if (typeof e == "boolean" && e == false) {
        this.dateFilter = null;

        this.changePage(1, true);
      }

      this.showDateSelector = null;
    },
    getDistrictName(id) {
      const district = this.allDistricts.find((d) => d._id == id);

      if (id && district) {
        return district.name;
      } else {
        return null;
      }
    },
    async getDistricts() {
      this.isProcessing = true;

      let url = "districts?_sort=name";

      if (this.userRole == "Supervisor" && this.userDistricts.length > 0) {
        url = url
          .concat("&_id_in=")
          .concat(
            this.userDistricts.map((district) => district._id).join("&_id_in=")
          );
      }

      return API.get(url)
        .then((retVal) => {
          this.allDistricts = retVal.data;

          const queryDistrict = this.allDistricts.find(
            (district) =>
              district.name.split(" ").join("_") == this.$route.query.district
          );

          if (queryDistrict) {
            this.currentDistrict = queryDistrict;

            this.$router.replace({ query: {} });
          }

          this.isProcessing = false;
        })
        .catch((err) => {
          console.error(err);

          this.isProcessing = false;
        });
    },
    async getContractors() {
      this.isProcessing = true;

      let url = "contractors";

      return API.get(url)
        .then((retVal) => {
          this.contractors = retVal.data;

          this.isProcessing = false;
        })
        .catch((err) => {
          console.error(err);

          this.isProcessing = false;
        });
    },
    editCase(c) {
      this.editingCase = c;

      if (c == "add") {
        this.currentCase = null;
      }
    },
    async closeEditCase(response) {
      const isNewCase = this.editingCase == "add";

      this.editingCase = null;

      if (response) {
        if (isNewCase) {
          Swal.fire("Case added", "", "success").then(async () => {
            this.isProcessing = true;

            const getCaseNumber = async () => {
              return await API.get(`cases/${response._id}`).then((retVal) => {
                if (retVal.data.caseNumber) {
                  this.searchByCaseNumber(retVal.data.caseNumber);

                  this.isProcessing = true;
                } else {
                  getCaseNumber();
                }
              });
            };

            getCaseNumber();
          });
        } else {
          const caseIndex = this.cases.findIndex((c) => c._id == response._id);

          if (caseIndex > -1) {
            response.index = this.cases[caseIndex].index;

            this.$set(this.cases, caseIndex, response);

            this.currentCase = response;

            Swal.fire("Case edit success", "", "success");
          }
        }
      }
    },
    initMap() {
      return new Promise((resolve) => {
        mapboxgl.accessToken = process.env.VUE_APP_MAPBOX_KEY;

        if (!isNaN(this.currentCase.lat) && !isNaN(this.currentCase.lng)) {
          if (!this.map) {
            this.map = new mapboxgl.Map({
              container: "map",
              style: "mapbox://styles/mapbox/dark-v9",
              center: [this.currentCase.lng, this.currentCase.lat],
              zoom: 14,
              interactive: false,
            });

            this.map.addControl(new mapboxgl.NavigationControl());

            this.map.on("load", () => {
              resolve();
            });
          } else {
            this.map.setCenter([this.currentCase.lng, this.currentCase.lat]);
            this.map.setZoom(14);
          }

          this.casePin = this.currentCase;
        }
      });
    },
    deleteImage(type, id, parentId) {
      Swal.fire({
        html: "Confirm delete image?",
        icon: "question",
        confirmButtonText: "Confirm",
        showCancelButton: true,
        buttonsStyling: false,
        reverseButtons: true,
        customClass: {
          confirmButton: "btn btn-sm btn-danger",
          cancelButton: "btn btn-sm btn-link",
          actions: "d-flex justify-content-between align-items-center",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          this.isProcessing = true;

          API.delete(`upload/files/${id}`)
            .then(() => {
              this.isProcessing = false;

              if (type == "verification") {
                const caseIndex = this.cases.findIndex(
                  (c) => c._id == this.currentCase._id
                );

                if (caseIndex > -1) {
                  let currentVerification = this.currentCase.verifications.find(
                    (v) => v._id == parentId
                  );

                  if (currentVerification) {
                    currentVerification.media =
                      currentVerification.media.filter((m) => m._id != id);
                  }
                }
              } else if (type == "before") {
                this.currentCase.media = this.currentCase.media.filter(
                  (m) => m._id != id
                );
              } else {
                this.currentCase[`media_${type}`] = this.currentCase[
                  `media_${type}`
                ].filter((f) => f._id != id);
              }

              Swal.fire("", "Image deleted", "success");
            })
            .catch((err) => {
              this.isProcessing = false;

              console.error(err);

              Swal.fire("", "Error deleting image", "error");
            });
        }
      });
    },
    addImage(type, parentId) {
      let uploader = document.createElement("input");
      uploader.type = "file";
      uploader.accept = "image/*";

      uploader.onchange = (event) => {
        if (event.target.files.length < 1) return;

        let fileModels = {
          ref: type == "verification" ? "verification" : "case",
          refId: parentId ? parentId : this.currentCase._id,
          field: "media",
          files: event.target.files,
        };

        if (type != "verification" && type != "before") {
          fileModels.field = `media_${type}`;
        }

        let endpoint = "upload";

        let fileName = "files";

        let formData = new FormData();

        Object.keys(fileModels).forEach((key) => {
          if (key != "files") {
            formData.append(key, fileModels[key]);
          } else {
            fileModels[key].forEach((file) => {
              formData.append(fileName, file);
            });
          }
        });

        this.isProcessing = true;

        API.postForm(endpoint, formData)
          .then(async (retVal) => {
            if (retVal.data.length > 0) {
              retVal.data.forEach((data) => {
                if (type == "verification") {
                  const caseIndex = this.cases.findIndex(
                    (c) => c._id == this.currentCase._id
                  );

                  if (caseIndex > -1) {
                    let currentVerification =
                      this.currentCase.verifications.find(
                        (v) => v._id == parentId
                      );

                    if (currentVerification) {
                      currentVerification.media.push(data);
                    }
                  }
                } else if (type == "before") {
                  if (this.currentCase.media) {
                    this.currentCase.media.push(data);
                  } else {
                    this.currentCase.media = [data];
                  }
                } else {
                  if (this.currentCase[`media_${type}`]) {
                    this.currentCase[`media_${type}`].push(data);
                  } else {
                    this.currentCase[`media_${type}`] = [data];
                  }
                }
              });
            }

            // if (
            //   type == "after" &&
            //   this.currentCase.status != "solved" &&
            //   !this.currentCase.solveDate
            // ) {
            //   let body = {
            //     status: "solved",
            //     solveDate: Math.floor(Date.now() / 1000),
            //   };

            //   await API.put(`cases/${this.currentCase._id}`, body);
            // }

            this.isProcessing = false;
            Swal.fire("", "Image uploaded", "success");
          })
          .catch((err) => {
            this.$emit("isLoading", false);

            console.error(err);

            this.isProcessing = false;
            Swal.fire("", "Image upload failed", "error");
          });
      };

      uploader.click();
    },
    async changePage(page, force) {
      const x = parseInt(page);

      if (x != this.currentPage || force) {
        if (x > this.totalPage || x < 1) {
          this.inputPage = this.currentPage;

          if (force) {
            await this.getCases();
          }
        } else {
          this.currentPage = x;
          this.inputPage = x;

          await this.getCases();
        }
      }
    },
    toggleSidebar() {
      this.showSidebar = !this.showSidebar;
    },
    goTo(id) {
      this.currentMedia = null;

      this.showSidebar = false;

      this.currentCase = this.cases.find((cse) => cse._id == id);

      this.afterCaptionModel = this.currentCase.afterCaption;

      this.casePin = null;

      const reportBodyContainer = this.$refs.reportBody;

      if (reportBodyContainer) {
        reportBodyContainer.scrollTo(0, 0);
      }

      if (id) {
        this.$nextTick(() => this.initMap());
      }
    },
    async countSummaryCase(query) {
      // console.log(query);

      return;
    },
    async getCases() {
      this.isProcessing = true;

      const caseListContainer = this.$refs.caseList;

      let query = "source_ne=socialMedia&_sort=timestamp:DESC";

      if (this.currentDistrict) {
        query += `&district=${this.currentDistrict._id}`;
      } else if (
        this.userRole == "Supervisor" &&
        this.userDistricts.length > 0
      ) {
        query += `&district_in=${this.userDistricts
          .map((ud) => ud._id)
          .join("&district_in=")}`;
      }

      if (this.workScopeFilter) {
        query += `&reportType=${this.workScopeFilter}`;
      }

      if (this.statusFilter) {
        if (this.statusFilter == "open") {
          query += "&status_nin=solved&status_nin=solvedPermanent";
        } else if (this.statusFilter == "closed_temporary") {
          query += "&status=solved";
        } else if (this.statusFilter == "closed_permanent") {
          query += "&status=solvedPermanent";
        }
      }

      if (this.dateFilter && this.dateFilter.start && this.dateFilter.end) {
        const _dateFilter = {
          start: Moment(this.dateFilter.start).startOf("day").toISOString(),
          end: Moment(this.dateFilter.end).endOf("day").toISOString(),
        };

        query += `&timestamp_gte=${_dateFilter.start}&timestamp_lte=${_dateFilter.end}`;
      }

      if (this.currentPage > 1) {
        query += `&_start=${(this.currentPage - 1) * this.pageLimit}`;
      }

      if (this.contractorFilter) {
        query += `&contractor=${this.contractorFilter}`;
      }

      if (this.currentPage == 1) {
        await this.countSummaryCase(query);
      }

      if (this.search) {
        query += `&caseNumber=${this.search}`;
      }

      if (this.currentPage == 1) {
        this.casesCount = (await API.get(`cases/count?${query}`)).data;

        this.totalPage = Math.ceil(this.casesCount / this.pageLimit);
      }

      try {
        const { data } = await API.get(`cases?${query}`);

        let _filteredData = data;

        if (this.verifiedFilter) {
          _filteredData = _filteredData.filter(
            (d) => d.verifications && d.verifications.length > 0
          );
        }

        this.cases = _filteredData.map((c, index) => {
          c.index = (this.currentPage - 1) * this.pageLimit + index + 1;

          return c;
        });

        if (caseListContainer) {
          caseListContainer.scrollTo(0, 0);
        }

        if (this.cases.length > 0) {
          this.goTo(this.cases[0]._id);
        } else {
          if (this.map) {
            this.map.remove();

            this.map = null;
          }

          this.goTo(null);
        }
      } catch (error) {}

      this.isProcessing = false;
    },
  },
  async mounted() {
    let _user = localStorage.getItem("user");

    if (_user) {
      _user = JSON.parse(_user);

      if (_user.districts && _user.districts.length > 0) {
        this.userDistricts = _user.districts.map((district) => {
          return {
            _id: district._id,
            name: district.name,
          };
        });
      }

      this.userRole = _user.role.name;
    }

    await this.getDistricts();

    await this.getContractors();

    if (this.$route.params.id) {
      this.search = this.$route.params.id;
    }

    await this.changePage(1, true);
  },
};
</script>